import React, { useState } from 'react';

import { observer } from 'mobx-react';

import { Checkbox, LbFormControlLabel } from '@infoods/lifebase-ui';

import { UseStepperReturn } from '../../../../../shared/hooks/useStepper';
import {
  ButtonRow,
  CoachCard,
} from '../../../../components/customer-self-setup-components';
import { SelectSubscriptionBlock } from '../../../../../payment';
import { coachStore } from '../../../../stores/customerSelfSetupStores/coachStore';
import { personalInfoStore } from '../../../../stores/customerSelfSetupStores/personalInfoStore';
import { getPriceView } from '../../../../../shared/utils/stringUtils';
import { useScrollToTop } from '../../../../../shared/hooks/useScrollToTop';
import { useSignUpSubscriptions } from '../../../../hooks/customerSelfSetupHooks/useSignUpSubscriptions';
import { entitySignUpStore } from '../../../../../shared/stores/entity/entitySignUpStore';
import { getRouteParam } from '../../../../../shared/utils/angularUtils';

type SelectSubscriptionStepProps = {
  stepperMethods: UseStepperReturn;
};

const SelectSubscriptionStep = observer(
  ({ stepperMethods }: SelectSubscriptionStepProps) => {
    const challengeId = getRouteParam('challengeId');

    const [separateBillingAcknowledged, setSeparateBillingAcknowledged] = useState(false);

    useScrollToTop();

    const { selectedCoach, consultationType } = coachStore;
    const { customerData } = personalInfoStore;
    const { billingTypeFlags } = entitySignUpStore;

    const {
      subscriptions,
      discountPercent,
      selectedSubscription,
      selectedSubscriptionTypeFlags,
      isNonPaidSubscription,
      applyPromoCode,
      setSelectedSubscriptionId,
      handleSubmit,
    } = useSignUpSubscriptions({
      entityId: selectedCoach!.entityId,
      customerEmail: customerData!.email,
      consultationType: consultationType!,
      challengeId,
    });

    const nonPaidYesButtonText = 'Submit Form';

    const yesButtonText = `Submit Form & Pay ${
      selectedSubscription ? getPriceView(selectedSubscription.initialPlanPriceFinal) : ''
    }`;

    const isSubmitButtonDisabled =
      !selectedSubscription ||
      (selectedSubscriptionTypeFlags.SELF_BILLING && !separateBillingAcknowledged);

    const submitButtonText =
      isNonPaidSubscription || billingTypeFlags.SELF_BILLING
        ? nonPaidYesButtonText
        : yesButtonText;

    return (
      <div>
        {selectedCoach && (
          <CoachCard coachInfo={selectedCoach} consultationType={consultationType} />
        )}
        <SelectSubscriptionBlock
          subscriptions={subscriptions}
          discountPercent={discountPercent}
          onApplyPromoCode={applyPromoCode}
          selectedSubscriptionId={selectedSubscription?.id || null}
          setSelectedSubscriptionId={setSelectedSubscriptionId}
          titleDescription="Access to the SWYMO app starts when your coach finalizes your setup and custom macro plan"
          showPromoCodeCard={!billingTypeFlags.SELF_BILLING}
        />
        {selectedSubscriptionTypeFlags.SELF_BILLING && (
          <LbFormControlLabel
            label="I understand that I will be billed separately by my coach"
            control={
              <Checkbox
                checked={separateBillingAcknowledged}
                onChange={(_, checked) => setSeparateBillingAcknowledged(checked)}
                color="primary"
              />
            }
          />
        )}
        <ButtonRow
          yesHandler={handleSubmit}
          yesText={submitButtonText}
          yesDisabled={isSubmitButtonDisabled}
          noHandler={stepperMethods.goToPreviousStep}
        />
      </div>
    );
  },
);

export { SelectSubscriptionStep };
